<script setup lang="ts">
/**
 * 形状选择：一排图标，**点一下立刻写入文档**（与形状工作台浮层同一套图标与语义）。
 *
 * 与浮层那条路的差别：
 *  · 目标不是「某一组」而是**当前选中集**（一个元素是长度为 1 的特例）；
 *  · 也没有「尺寸口径」开关 —— 口径沿用形状工作台那份设置，面板里不摆第二个开关；
 *  · 当前项靠 `inferShapeKind` 从几何反推（浮层靠 applied 记账）；
 *    反推不出来时 `value` 为 null，**一格都不点亮**（宁可不说，也不说错）。
 */
import { SHAPE_ICON_D, SHAPE_LIST, type ShapeKind } from '@/core/shapes';

const props = defineProps<{
  value: ShapeKind | null;
}>();
const emit = defineEmits<{ change: [kind: ShapeKind] }>();
</script>

<template>
  <div class="shp-grid">
    <button
      v-for="def in SHAPE_LIST"
      :key="def.kind"
      class="shp-shape"
      :class="{ 'is-active': def.kind === props.value }"
      data-field="shape-kind"
      :data-kind="def.kind"
      :title="def.label"
      @click="emit('change', def.kind)"
    >
      <svg viewBox="0 0 16 16" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round">
        <path :d="SHAPE_ICON_D[def.kind]" />
      </svg>
    </button>
  </div>
</template>
